import Column from '@components/Column';
import FilterOption from '@components/FilterOption';
import Header from '@components/Header';
import PdfViewer from '@components/PdfViewer';
import Text from '@components/Text';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import useSetProjectId from './hooks/useSetProjectId';
import useTerms from './hooks/useTerms';
import styles from './styles.module.scss';

interface Params {
    termCategoryId: string;
    hideFilter?: boolean;
}

const TermDetailActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { t } = useTranslation('termDetail');
    const { termCategoryId, hideFilter } = params;
    const {
        terms, currentTerm, termId, setTermId,
    } = useTerms(termCategoryId);
    useSetProjectId();
    return (
        <AppScreen>
            <Header title={currentTerm?.title || ''} />
            <Column className={styles.container}
                spacing={16} >
                {(!hideFilter) && (
                    <FilterOption title={t('filter.title')}
                        value={termId}
                        onChange={setTermId}
                        options={terms?.map((term) => ({
                            label: term.title,
                            value: term.id,
                        }))}/>
                )}
                {currentTerm?.fileUrl ? (
                    <PdfViewer fileUrl={currentTerm.fileUrl}/>
                ) : (
                    <Text>{t('empty')}</Text>
                )}
            </Column>
        </AppScreen>
    );
};

export default TermDetailActivity;
